import { RouteObject } from "react-router-dom";
import GeneralIntegrationLanding from "./components/landing/landing";

export interface GeneralIntegrationRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: GeneralIntegrationRoute[];
}
export const ixGeneralIntegrationRoutes: GeneralIntegrationRoute[] = [
  {
    path: "/integration-hub/general-integration",
    element: <GeneralIntegrationLanding />,
  },
];
